import React, { useContext, useState } from 'react';
import { Button, Checkbox, Col, Form, Modal, Row, Space } from 'antd';
import cx from 'classnames';
import { useRequest } from 'ahooks';
import moment from 'moment';
import styles from '@/page-components/detail/Intro/styles.module.less';
import Spread from '@/page-components/detail/Intro/spread';
import { ExamMethod } from '@/types/index';
import ChooseExamTime from '@/page-components/detail/Intro/choose_exam_time';
import OrganizationPeopleSelect from '@/page-components/detail/Intro/OrganizationSelect/organization_people';
import MustPass from '@/page-components/detail/Intro/must_pass';
import ShouldPass from '@/page-components/detail/Intro/should_pass';
import Coupon from '@/page-components/detail/Intro/Coupon/index';
import { TCouponItem } from '@/page-components/detail/Intro/Coupon/couponItem';
import { DetailContext } from '@/context/detailContext';
import { calcTime } from '@/utils/index';

type TSignupData = {
  examDuration: number;
  shouldPrice: number;
  price: number;
  couponPrice: number;
  isAgree: boolean;
  peopleNum: number;
  method: ExamMethod;
  couponInfo: TCouponItem;
  certTypeName: string;
  isPass: boolean;
  premise: string | null;
  mustPassOpt: {
    id: string;
    isPass?: boolean;
    label: string;
    value: string;
    price: number;
    student_price: number | null;
    supplierPrice: number | null;
  }[];
};

type TPCSignupModal = {
  visible: boolean;
  isMySelfSignup: boolean;
  onSignupDataChange: (data: object) => void; // 报名信息改变的时候
  onSignUp: (params: object) => Promise<any>; // 报名函数
  onCancel: () => void; // 取消函数
  signupData: TSignupData;
  shouldPassOpt?: {
    id: string;
    isPass?: boolean;
    label: string;
    value: string;
    price: number;
    student_price?: number;
  }[];
};

const PCSignupModal: React.FC<TPCSignupModal> = ({
  shouldPassOpt,
  signupData,
  onCancel,
  onSignUp,
  onSignupDataChange,
  isMySelfSignup,
  visible,
}) => {
  // 从context继承
  const contextProps = useContext(DetailContext);
  const { userInfo, cert_id, data } = contextProps;
  const {
    type,
    exam_info: { fcrpd_text, signup_text },
  } = data;
  const {
    IDNum,
    mobile,
    realname,
    isPassStudentAuthentication,
    isOrganizationAdmin,
    username,
    isSupplierState,
  } = userInfo;
  const [form] = Form.useForm();
  const [examStartTime, setExamStartTime] = useState<number>(); // 考试开始时间
  const calcMoney = (options: any[]) => {
    let money = 0;
    options.forEach((opt) => {
      if (!opt.isPass) {
        if (isPassStudentAuthentication && isMySelfSignup) {
          if (opt.student_price) {
            money += opt.student_price;
          } else {
            money += opt.price;
          }
        } else {
          money += opt.price;
        }
      }
    });
    return money;
  };
  const { runAsync: signup, loading: signupPLoading } = useRequest(
    (params: object) => {
      return onSignUp(params);
    },
    {
      manual: true,
    },
  );
  const onChange = (receiveCoupons: TCouponItem[]) => {
    let couponPrice = 0;
    console.log('receiveCoupons是');
    console.log(receiveCoupons);
    receiveCoupons.forEach((coupon) => {
      couponPrice += coupon.coupon_value;
    });
    onSignupDataChange({ couponPrice, couponInfo: receiveCoupons[0] });
  };
  return (
    <Modal
      centered
      destroyOnClose
      width="1100px"
      title={isMySelfSignup ? '认证报名' : '为他人报名'}
      open={visible}
      footer={null}
      onCancel={onCancel}
      bodyStyle={{ padding: 0 }}
    >
      <div className={styles.signup_modal_wrapper}>
        <div className={styles.signup_modal_wrapper_left}>
          <div className={styles.left_tips}>
            <Spread
              signupText={
                type === 'fcrpd' && !isMySelfSignup ? fcrpd_text : signup_text
              }
            />
          </div>
          <Row className={cx(styles.row, styles.row_gap)}>
            <Col span={12}>
              {isMySelfSignup ? (
                <Space>
                  <span className={styles.tips_text}>考生姓名：</span>
                  <span className={styles.data_text}>
                    {realname || username}
                  </span>
                </Space>
              ) : (
                <Space size={22}>
                  <span className={styles.tips_text}>考试时长：</span>
                  <span className={styles.data_text}>
                    {calcTime(signupData.examDuration)}
                  </span>
                </Space>
              )}
            </Col>
            <Col span={12}>
              {isMySelfSignup &&
                  <Space>
                    <span className={styles.tips_text}>身份证号：</span>
                    <span className={styles.data_text}>{IDNum}</span>
                  </Space>
              }
            </Col>
          </Row>
          <Row className={cx(styles.row)}>
            <Col span={24}>
              <Space size={22}>
                <span className={styles.tips_text}>手机号：</span>
                <Space>
                  <span className={styles.data_text}>{mobile}</span>
                  <a href={process.env.NEXT_PUBLIC_PASSPORT_URL}>修改手机号</a>
                </Space>
              </Space>
            </Col>
          </Row>
          <Row className={cx(styles.row, styles.row_gap)}>
            <Col span={24}>
              <Space size={22}>
                <span className={styles.tips_text} />
                <p className={styles.small_tips_text}>
                  手机号用于接收报名信息，考试成绩提醒，请确认填写无误。
                </p>
              </Space>
            </Col>
          </Row>
          <Form colon={false} form={form} preserve={false}>
            {signupData.method !== ExamMethod.anytime && (
              <ChooseExamTime
                onSchTimeChange={(time) => {
                  console.log('time是');
                  console.log(time);
                  setExamStartTime(time);
                }}
                form={form}
                certId={cert_id}
                method={signupData.method}
              />
            )}
            {!isMySelfSignup && (
              <OrganizationPeopleSelect
                  form={form}
                certId={cert_id}
                onChange={(selectKey) => {
                  console.log('选的人是');
                  console.log(selectKey);
                  onSignupDataChange({ peopleNum: selectKey.length || 1 });
                }}
              />
            )}
            <MustPass
              form={form}
              isMySelfSignup={isMySelfSignup}
              data={signupData.mustPassOpt}
            />
            {shouldPassOpt && (
              <ShouldPass
                form={form}
                isPassStudentAuthentication={isPassStudentAuthentication}
                passNum={1}
                data={shouldPassOpt}
                onChange={(checkValue) => {
                  console.log('checkValue');
                  console.log(checkValue);
                  const options = shouldPassOpt?.filter((opt) =>
                    checkValue.includes(opt.value),
                  );
                  const money = calcMoney(options);
                  onSignupDataChange({ shouldPrice: money });
                }}
              />
            )}
          </Form>
        </div>
        <div className={styles.signup_modal_wrapper_right}>
          <Coupon
            type={type}
            isMySelfSignup={isMySelfSignup}
            isOrganizationAdmin={isOrganizationAdmin}
            onChange={onChange}
            totalPrice={
              signupData.price +
                signupData.shouldPrice -
                signupData.couponPrice <=
              0
                ? 0
                : signupData.peopleNum *
                    (signupData.price + signupData.shouldPrice) -
                  signupData.couponPrice
            }
          />
          <div className={styles.signup_modal_wrapper_footer}>
            <Space className={styles.price_wrapper}>
              <span>合计:</span>
              {signupData && (
                <span className={styles.price_text}>
                  ￥
                  {signupData.price +
                    signupData.shouldPrice -
                    signupData.couponPrice <=
                  0
                    ? 0
                    : signupData.peopleNum *
                        (signupData.price + signupData.shouldPrice) -
                      signupData.couponPrice}
                </span>
              )}
            </Space>
            <div>
              <Checkbox
                value={signupData.isAgree}
                onChange={(e) => {
                  onSignupDataChange({ isAgree: e.target.checked });
                }}
                className={styles.checkbox_text}
              >
                <span style={{ color: 'black' }}>我已阅读并同意</span>
                <a
                  rel="noreferrer"
                  href="https://bbs.fanruan.com/thread-132684-1-1.html"
                  target="_blank"
                >
                  《帆软认证考试服务协议》
                </a>
              </Checkbox>
            </div>
            <Button
              loading={signupPLoading}
              disabled={signupPLoading}
              className={styles.cancel_btn}
              type="primary"
              onClick={async () => {
                try {
                  const values = await form.validateFields();
                  if (examStartTime) {
                    values.examStartTime = moment(examStartTime);
                  }
                  await signup(values);
                } catch (e: any) {
                  const { errorFields = [] } = e;
                  if (errorFields.length > 0) {
                    const name = errorFields[0]?.name[0];
                    form.scrollToField(name, { behavior: 'smooth' });
                  }
                }
              }}
            >
              确认报名
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
export default PCSignupModal;
